import React, { useEffect, useState, Fragment } from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Chip } from 'material-ui';

/**
 * @type {Object.<string, React.CSSProperties>}
 */
const commonChipStyle = {
    style: {
        cursor: 'pointer',
    },
    labelStyle: {
        fontSize: '12px', 
        lineHeight: '20px',
    },
};

export const statuses = {
    new: {
        chip: <Chip style={{ backgroundColor: '#82C3FF', ...commonChipStyle.style }} labelStyle={commonChipStyle.labelStyle}>New</Chip>
    },
    confirmed: {
        chip: <Chip style={{ backgroundColor: '#7ADCCA', ...commonChipStyle.style }} labelStyle={commonChipStyle.labelStyle}>Confirmed</Chip>
    },
    inProgress: {
        chip: <Chip style={{ backgroundColor: '#F8BF50', ...commonChipStyle.style }} labelStyle={commonChipStyle.labelStyle}>In progress</Chip>
    },
    fixed: {
        chip: <Chip style={{ backgroundColor: '#75C422', ...commonChipStyle.style }} labelStyle={commonChipStyle.labelStyle}>Fixed</Chip>
    },
    notBug: {
        chip: <Chip style={{ backgroundColor: '#C9CEF7', ...commonChipStyle.style }} labelStyle={commonChipStyle.labelStyle}>Not bug</Chip>
    },
};

export default function Status({ status, handleChangeStatus, ...props }) {
    const [value, setValue] = useState(status);

    useEffect(() => {
        setValue(status);
    }, [status]);

    const handleChange = (_e, _i, v) => {
        if (status === v) return;
        handleChangeStatus(v);
    }

    return (
        <span
            style={{ height: '28px', ...(props.style || {}) }}
            className={ props.className || '' }
        >
            <SelectField
                value={value}
                selectionRenderer={(value) => statuses[value].chip}
                onChange={handleChange}
                iconStyle={{
                    height: '24px',
                    width: '24px',
                    padding: 0,
                    top: '-4px',
                }}
                style={{
                    height: '28px',
                    width: '164px',
                    lineHeight: '24px',
                    position: 'relative',
                    textAlign: 'center',
                    marginTop: '2px',
                }}
                menuStyle={{
                    position: 'absolute',
                }}
                underlineStyle={{
                    position: 'relative',
                    top: '21px',
                }}
                listStyle={{
                    padding: '4px 0',
                }}
                menuItemStyle={{
                    padding: 'auto 0',
                }}
            >
                {
                    Object.entries(statuses).map(([key, value]) => {
                        return (<MenuItem 
                            key={key} 
                            value={key} 
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >{value.chip}</MenuItem>)
                    })
                }
            </SelectField>
        </span>
    );
}



// WEBPACK FOOTER //
// ./app/components/Issues/List/Status.jsx